import {
  Bell,
  Blocks,
  BookOpen,
  ChevronsUpDown,
  Clock,
  Command,
  CornerDownRight,
  Database,
  FaceSlightlySmiling,
  FileSpreadsheet,
  FileText,
  Folder,
  Globe,
  Hash,
  Infinity as InfinityIcon,
  Kanban,
  KeyRound,
  Languages,
  Library,
  ListTree,
  Lock,
  MessagesSquare,
  Mic,
  Palette,
  PanelRight,
  Phone,
  Plug,
  Plus,
  ScrollText,
  Search,
  SendHorizontal,
  Server,
  ShieldCheck,
  Sparkles,
  UserPlus,
  UserRoundCog,
  Users,
  UsersRound,
  Video,
  WandSparkles,
  X,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * 41 icon mà bản thiết kế dùng, KHOÁ THEO ĐÚNG TÊN trong thuộc tính `data-lucide` của nó.
 *
 * Vì sao khoá theo tên của thiết kế chứ không để mỗi chỗ tự import: người implement đọc
 * `template.html` thấy `data-lucide="messages-square"` thì viết `name="messages-square"` — không
 * phải dịch sang PascalCase, không phải đoán.
 *
 * Thiết kế nạp lucide từ CDN; CSP `script-src 'self'` chặn cách đó. Ở đây `lucide-react` là
 * dependency BUILD-TIME (chỉ xuất SVG), không gọi mạng, và named import nên tree-shake được.
 *
 * Hai key không gọi thẳng tên component được:
 * - `Infinity` trùng với global `Infinity` của JavaScript nên phải đổi tên khi import.
 * - `smile` đã được lucide đổi tên chuẩn thành `face-slightly-smiling` sau ngày bản thiết kế
 *   được vẽ. Vẫn là cùng một hình. Import theo tên MỚI chứ không dùng alias `Smile` còn sót lại:
 *   alias kiểu đó là thứ biến mất ở major sau.
 *
 * BAO NHIÊU CỦA CÁI NÀY LÀ MÁY CANH — nói thẳng để đừng ai tin quá:
 * - Có máy canh: một key trỏ nhầm sang icon khác (`Icon.test.tsx` đọc class `lucide-…` mà
 *   lucide tự dán, so với key).
 * - Có máy canh: registry mất hoặc thừa entry so với danh sách 41 tên đã đo.
 * - KHÔNG có máy canh: danh sách 41 tên đó còn đúng với thiết kế hay không. Bundle thiết kế nằm
 *   ngoài repo nên không cổng nào đo lại được; thiết kế đổi icon ⇒ phải grep `data-lucide` lại
 *   bằng tay rồi sửa cả hai đầu.
 */
export const ICONS = {
  bell: Bell,
  blocks: Blocks,
  'book-open': BookOpen,
  'chevrons-up-down': ChevronsUpDown,
  clock: Clock,
  command: Command,
  'corner-down-right': CornerDownRight,
  database: Database,
  'file-spreadsheet': FileSpreadsheet,
  'file-text': FileText,
  folder: Folder,
  globe: Globe,
  hash: Hash,
  infinity: InfinityIcon,
  kanban: Kanban,
  'key-round': KeyRound,
  languages: Languages,
  library: Library,
  'list-tree': ListTree,
  lock: Lock,
  'messages-square': MessagesSquare,
  mic: Mic,
  palette: Palette,
  'panel-right': PanelRight,
  phone: Phone,
  plug: Plug,
  plus: Plus,
  'scroll-text': ScrollText,
  search: Search,
  'send-horizontal': SendHorizontal,
  server: Server,
  'shield-check': ShieldCheck,
  smile: FaceSlightlySmiling,
  sparkles: Sparkles,
  'user-plus': UserPlus,
  'user-round-cog': UserRoundCog,
  users: Users,
  'users-round': UsersRound,
  video: Video,
  'wand-sparkles': WandSparkles,
  x: X,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;
